import styled from 'styled-components';
import colors from 'styles/colors';

export interface RatingStyledProps {
  $inAdminForm?: boolean;
}

export const RatingStyled = styled.section <RatingStyledProps>`
  ${({ $inAdminForm }) => ($inAdminForm ? 'padding-block: 24px;' : '')}
  min-width: 0;
  width: 100%;
`;

export const RatingHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 24px;
  padding-block: 16px;
  min-width: 0;
  width: 100%;
  
  h3 {
    margin: 0;
    padding: 0;
  }
`;

export const RatingHeaderActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 8px;
`;

export const RatingBodyStyled = styled.div`
  min-width: 0;
  width: 100%;
`;

export const RatingStarsStyled = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: fit-content;
`;

interface CurrentRatingStyledProps {
  $width?: number;
}

export const CurrentRatingStyled = styled.div<CurrentRatingStyledProps>`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: ${({ $width }) => ($width ? $width : 0)}%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
`;

export const RatingFormStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 100%;
`;

export const RatingSelectWrapperStyled = styled.div`
  min-width: 160px;
`;

export const RatingNoteStyled = styled.p`
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.gray};
  word-break: break-word;
  white-space: pre-wrap;
`;

export const RatingFormActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
